export default __webpack_public_path__ + "static/media/Investors-Meet-09-09-2026.d5610623.pdf";